import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonService } from 'src/app/shared/services/common.service';
import { FormGroup, FormArray } from '@angular/forms';
import { BaseFormGroup } from 'src/app/shared/form-input-components/base-form-group';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { InvoiceViewService } from '../invoice-view/invoice-view.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Subject, forkJoin, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IDatePickerConfig } from 'mis-crystal-design-system/datepicker_v2';
import { parseZone } from 'moment';
@Component({
  selector: 'app-invoice-edit',
  templateUrl: './invoice-edit.component.html',
  styleUrls: ['./invoice-edit.component.scss']
})
export class InvoiceEditComponent extends BaseFormGroup implements OnInit, OnDestroy {

  public formDetails: FormGroup;
  public stepperReference: FormArray;
  private bookingId: string;
  public isLoading = false;
  public isPageLoading = true;
  public stepperDetails: any[] = [];
  public activeStep = 0;
  public config: any = {};
  public fileToUpload = [];
  public fileName = [];
  public uploadType: string;
  public showFileUploadModal: boolean;
  public uploadFileError: string;
  public showUploadSuccess: boolean;
  public details: any;
  public invoiceDetailsError: string;
  vendors: any;
  uploadedDocumentList;
  tollSelectedFiles = {type: 'TOLL', files: [], fileNames: [], displayName: ''};
  parkingSelectedFiles = {type: 'PARKING', files: [], fileNames: [], displayName: ''};
  permitSelectedFiles = {type: 'PERMIT', files: [], fileNames: [], displayName: ''};
  invoiceSelectedFiles = {type: 'INVOICE', files: [], fileNames: [], displayName: ''};
  othersSelectedFiles = {type: 'OTHERS', files: [], fileNames: [], displayName: ''};

  tollUploadedFiles = {type: 'TOLL', fileNames: [], displayName: ''};
  parkingUploadedFiles = {type: 'PARKING', fileNames: [], displayName: ''};
  permitUploadedFiles = {type: 'PERMIT', fileNames: [], displayName: ''};
  invoiceUploadedFiles = {type: 'INVOICE', fileNames: [], displayName: '' };
  othersUploadedFiles = {type: 'OTHERS', fileNames: [], displayName: ''};

  previewUrl: any;
  selectedFileName: string;
  private destroy$ = new Subject();
  selectedFileType: any;
  showPreview: boolean;
  downloadZipConfig: any;
  tripStatus;
  enableForms = true;
  miscelleneousConfig;
  saveChangesButton = false;
  countError: number;
  invoiceEditConfig: any;
  adjustmentConfig: any;
  totalSize = 0;
  saveButtonDisabled: boolean;
  showFileSizeError: boolean;
  enableForNoShow: any;

  datepickerConfig: Partial<IDatePickerConfig> = {
    minDate: "",
    format: "DD/MM/YYYY",
    maxDate: "",
    timezone: "Asia/Kolkata",
  };
  selectedDate: string = parseZone().format("DD/MM/YYYY");
  invoiceEditDates = {
    tripEndDate: '',
    tripStartDate: '',
    dutyEndDate: '',
    dutyStartDate: ''
  };
  invoiceEditTime = {
    tripEndTime: '',
    tripStartTime: '',
    dutyEndTime: '',
    dutyStartTime: ''
  };
  startDutyTime = '';
  endDutyTime = '';
  startTripTime = '';
  endTripTime = '';

  constructor(
            private commonService: CommonService,
            private router: Router,
            private activatedRoute: ActivatedRoute,
            private invoiceViewService: InvoiceViewService,
            private authService: AuthService,

            ) {
    super();
    const state = this.router.getCurrentNavigation().extras.state;
    this.tripStatus = state ? state.tripStatus : null;
    this.enableForNoShow = state.isNoShowEnable;
  }

  ngOnInit() {
    this.formDetails = new FormGroup({});
    this.stepperReference = new FormArray([]);
    this.activatedRoute.queryParams.subscribe(params => {
      this.bookingId = params.bookingId;
    });
    this.commonService.getEtsData().subscribe((response) => {
      this.vendors = response.vendors;
    });
    if (!this.commonService.workflowConfig) {
      this.commonService.fetchWorkflowConfig().subscribe((response) => {
        this.commonService.workflowConfig = response;
        this.checkFormDisability();
      });
    } else {
      this.checkFormDisability();
    }
    this.miscelleneousConfig = this.commonService.miscConfig;

    const searchQuery = {
      bookingId: this.bookingId,
      buid: this.authService.user.buId,
      client: this.authService.client.client,
      employeeguid: this.authService.user.employeeGuid
    };
    this.invoiceViewService.fetchInvoiceBookingDetail(searchQuery).subscribe((response) => {
      this.details = response;
      this.commonService.fetchConfig().subscribe((res) => {
        this.invoiceEditConfig = this.commonService.getConfigForElementKey(res, 'Edit Booking Parameters For Billing');
        this.adjustmentConfig = this.commonService.getConfigForElementKey(this.invoiceEditConfig, 'Adjustments');
        if (this.adjustmentConfig.config.visibility.visible) {
          this.getAllDocuments();
        } else {
          this.setup();
        }
      });
    }, (err) => {
      this.invoiceDetailsError = err;
      this.isPageLoading = false;
    });
  }

  checkFormDisability() {
    if (this.tripStatus === 'TRIP_COMPLETED' || this.tripStatus === 'DUTY_COMPLETED') {
      this.enableForms = this.commonService.workflowConfig['enableTripParamsEditOnAutoTripCompletion'];
    } else if (this.tripStatus === 'MANUALLY_COMPLETED') {
      this.enableForms = this.commonService.workflowConfig['enableTripParamsEditOnManualTripCompletion'];
    } else if (this.tripStatus === 'TRIP_NO_SHOW') {
      this.enableForms = this.enableForNoShow;
    }
  }

  getAllDocuments() {
    const query = {
      bookingId: this.bookingId,
      clientId: this.authService.client.client,
      buid: this.authService.user.buId,
    };
    this.invoiceViewService.getAllDocumentList(query).
    pipe(takeUntil(this.destroy$))
    .subscribe((response) => {
      this.uploadedDocumentList = response ? response.uploadedFiles : null;
      this.setup();
      if (this.uploadedDocumentList) { this.extractUploadedFilesCategory(); }
    });

  }

  extractUploadedFilesCategory() {
    this.uploadedDocumentList.forEach((list) => {
      this.totalSize += list.filesize || 0;
      if (list.documentType === 'TOLL') {
        if (!this.tollUploadedFiles.displayName) {
          this.tollUploadedFiles.displayName = this.setDisplayNameForCategory('toll');
        }
        this.tollUploadedFiles.fileNames.push(list);
      } else if (list.documentType === 'PARKING') {
        if (!this.parkingUploadedFiles.displayName) {
          this.parkingUploadedFiles.displayName = this.setDisplayNameForCategory('parking');
        }
        this.parkingUploadedFiles.fileNames.push(list);
      } else if (list.documentType === 'PERMIT') {
        if (!this.permitUploadedFiles.displayName) {
          this.permitUploadedFiles.displayName = this.setDisplayNameForCategory('permit');
        }
        this.permitUploadedFiles.fileNames.push(list);
      } else if (list.documentType === 'INVOICE') {
        if (!this.invoiceUploadedFiles.displayName) {
          this.invoiceUploadedFiles.displayName = this.setDisplayNameForCategory('vendorBillAmount');
        }
        this.invoiceUploadedFiles.fileNames.push(list);
      } else if (list.documentType === 'OTHERS') {
        if (!this.othersUploadedFiles.displayName) {
          this.othersUploadedFiles.displayName = this.setDisplayNameForCategory('otherCost');
        }
        this.othersUploadedFiles.fileNames.push(list);
      }
    });
  }

  setup() {
      this.downloadZipConfig = this.getConfigForElementKey(this.invoiceEditConfig, 'downloadZip');
      this.invoiceEditConfig.sectionConfigList.forEach((sectionConfig) => {
        if (sectionConfig.config.visibility.visible) {
          this.stepperDetails.push({
            elementKey: sectionConfig.elementKey,
            label: sectionConfig.config.displayName,
            completed: true
          });
          this.saveConfig(sectionConfig);
          this.setupTabForm(sectionConfig);
             }
      });
      this.isPageLoading = false;
  }

  saveConfig(sectionConfig) {
    if (sectionConfig.elementKey === 'Booking Details') {
      this.config.bookingConfig = sectionConfig.elementConfigList;
    } else if (sectionConfig.elementKey === 'Trip Details') {
      this.config.tripConfigPart1 = sectionConfig.elementConfigList.slice(0, 3);
      this.config.tripConfigPart2 = sectionConfig.elementConfigList.slice(3, sectionConfig.elementConfigList.length);
    } else if (sectionConfig.elementKey === 'Adjustments') {
      this.config.adjustment = sectionConfig.elementConfigList.filter((field) => {
        if (field.config.elementType) {
          return true;
        }
      });
    }
  }

  setupTabForm(sectionConfig) {
    const formGroup = new FormGroup({});
    this.constructForm(formGroup, sectionConfig.elementConfigList);
    if (sectionConfig.elementKey === 'Booking Details') {
      const bookingDetails = {
        spotBookingType : this.details['bookingInfo'].bookingType,
        vehicleType: this.details['bookingInfo'].cabType,
        city : this.details['bookingInfo'].city,
        vendor: this.details['bookingInfo'].vendorGuid,
      };
      formGroup.patchValue(bookingDetails);
      if (!this.enableForms) { formGroup.disable(); }
    } else if (sectionConfig.elementKey === 'Trip Details') {
      const tripDetails = {
        endDutyTime: this.details['tripInfo'].endDutyTime,
        endEmptyLeg: this.details['tripInfo'].endEmptyLeg,
        endGarageKm: this.details['tripInfo'].endGarageKm,
        endTripTime: this.details['tripInfo'].endTripTime,
        startDutyTime: this.details['tripInfo'].startDutyTime,
        startEmptyLeg: this.details['tripInfo'].startEmptyLeg,
        startGarageKm: this.details['tripInfo'].startGarageKm,
        startTripTime: this.details['tripInfo'].startTripTime,
        tripDistance: this.details['tripInfo'].tripDistance,
      };

      formGroup.patchValue(tripDetails);
      if (!this.enableForms) { formGroup.disable(); }
    } else if (sectionConfig.elementKey === 'Adjustments') {
      const adjustmentDetails = {
        toll : this.details['adjustmentInfo'].toll,
        parking: this.details['adjustmentInfo'].parking,
        permit : this.details['adjustmentInfo'].permit,
        gstRate: this.details['adjustmentInfo'].gstRate,
        penalty: this.details['adjustmentInfo'].penalty,
        waitingTime : this.details['adjustmentInfo'].waitingTime,
        additionalBata: this.details['adjustmentInfo'].additionalBata,
        otherCost : this.details['adjustmentInfo'].otherCost,
        comments: this.details['adjustmentInfo'].comments,

        vendorBillAmount: this.details['adjustmentInfo'].vendorBillAmount ?
          (Number(this.details['adjustmentInfo'].vendorBillAmount)).toFixed(2) : '',
      };
      formGroup.patchValue(adjustmentDetails);
    }
    this.formDetails.addControl(sectionConfig.elementKey, formGroup);
    this.stepperReference.push(formGroup);

    if (this.formDetails.get('Trip Details')){
      this.invoiceEditDates.dutyEndDate = this.formDetails.get('Trip Details').get('endDutyTime').value.split(' ')[0];
      this.invoiceEditDates.tripEndDate = this.formDetails.get('Trip Details').get('endTripTime').value.split(' ')[0];
      this.invoiceEditDates.dutyStartDate = this.formDetails.get('Trip Details').get('startDutyTime').value.split(' ')[0];
      this.invoiceEditDates.tripStartDate = this.formDetails.get('Trip Details').get('startTripTime').value.split(' ')[0];
    }
  }

  getTabFormValue(tabName) {
    const formGroup = this.formDetails.get(tabName);
    if (formGroup instanceof FormGroup) {
      if (tabName == 'Trip Details'){
        this.formDetails.get('Trip Details').setValue({
          endDutyTime: this.endDutyTime,
          endEmptyLeg: +formGroup.get('endEmptyLeg').value,
          endGarageKm: this.details['tripInfo'].endGarageKm,
          endTripTime: this.endTripTime,
          startDutyTime: this.startDutyTime,
          startEmptyLeg: +formGroup.get('startEmptyLeg').value,
          startGarageKm: this.details['tripInfo'].startGarageKm,
          startTripTime: this.startTripTime,
          tripDistance: +formGroup.get('tripDistance').value,
        });
      }
      return formGroup.getRawValue();
    }
    return null;
  }

  onInvoiceDateChange(e, label){
    this.selectedDate = e;
    switch (label){
      case 'startDutyTime': {
        this.invoiceEditDates.dutyStartDate = e;
        break;
      }
      case 'endDutyTime': {
        this.invoiceEditDates.dutyEndDate = e;
        break;
      }
      case 'startTripTime': {
        this.invoiceEditDates.tripStartDate = e;
        break;
      }
      case 'endTripTime': {
        this.invoiceEditDates.tripEndDate = e;
        break;
      }
    }
  }

  timeChangeCallback(e, label){
    switch (label){
      case 'startDutyTime': {
        this.invoiceEditTime.dutyStartTime = e;
        break;
      }
      case 'endDutyTime': {
        this.invoiceEditTime.dutyEndTime = e;
        break;
      }
      case 'startTripTime': {
        this.invoiceEditTime.tripStartTime = e;
        break;
      }
      case 'endTripTime': {
        this.invoiceEditTime.tripEndTime = e;
        break;
      }
    }

  }

  getSelectedDate(label){
    switch (label){
      case 'startDutyTime': {
        return this.invoiceEditDates.dutyStartDate;
      }
      case 'endDutyTime': {
        return this.invoiceEditDates.dutyEndDate;
      }
      case 'startTripTime': {
        return this.invoiceEditDates.tripStartDate;
      }
      case 'endTripTime': {
        return this.invoiceEditDates.tripEndDate;
      }
      default: return this.selectedDate;
    }
  }

  getBookingInfo() {
    const formValue = this.formDetails.get('Booking Details') ? this.formDetails.get('Booking Details').value : null;
    return {
      bookingType: formValue ? formValue['spotBookingType'] : null,
      cabGuid: null,
      cabType: formValue ? formValue['vehicleType'] : null,
      city: formValue ? formValue['city'] :  null,
      vendorGuid: formValue ? formValue['vendor'] : null
    };
  }

  downloadZip() {
    const queryParams = {
      bookingID: this.bookingId,
      buid: this.authService.user.buId,
      client: this.authService.client.client,
    };
    this.invoiceViewService.downloadAllDocAsZip(queryParams).
    pipe(takeUntil(this.destroy$)).
    subscribe((data: any) => {
      const a = document.createElement('a');
      const blob = new Blob([data.body], {type : "application/zip"});
      a.href = URL.createObjectURL(blob);
      a.download = "files.zip";
      a.click();
    });
}

  setFilesForUpload() {
    const fileToUpload = [];
    const multiPart = [];
    this.tollSelectedFiles.fileNames.forEach((file, index) => {
      const upload = {
        documentType: 'TOLL',
        fileName: file,
        isDeleted: false
      };
      fileToUpload.push(upload);
      multiPart.push(this.tollSelectedFiles.files[index]);
    });
    this.parkingSelectedFiles.fileNames.forEach((file, index) => {
      const upload = {
        documentType: 'PARKING',
        fileName: file,
        isDeleted: false
      };
      fileToUpload.push(upload);
      multiPart.push(this.parkingSelectedFiles.files[index]);

    });
    this.permitSelectedFiles.fileNames.forEach((file, index) => {
      const upload = {
        documentType: 'PERMIT',
        fileName: file,
        isDeleted: false
      };
      fileToUpload.push(upload);
      multiPart.push(this.permitSelectedFiles.files[index]);
    });
    this.invoiceSelectedFiles.fileNames.forEach((file, index) => {
      const upload = {
        documentType: 'INVOICE',
        fileName: file,
        isDeleted: false
      };
      fileToUpload.push(upload);
      multiPart.push(this.invoiceSelectedFiles.files[index]);
    });
    this.othersSelectedFiles.fileNames.forEach((file, index) => {
      const upload = {
        documentType: 'OTHERS',
        fileName: file,
        isDeleted: false
      };
      fileToUpload.push(upload);
      multiPart.push(this.othersSelectedFiles.files[index]);
    });
    return {uploadedFiles: fileToUpload, uploadingFiles: multiPart};
  }

  checkVisibilityy(miscConfigKey, adjustmentkey) {
    return  this.saveChangesButton && this.miscelleneousConfig[miscConfigKey]
            && this.miscelleneousConfig[miscConfigKey] === 'true'
            && this.formDetails.get('Adjustments').get(adjustmentkey).value
            && !this.checkSelectedFile(adjustmentkey);
  }

  checkSelectedFile(key) {
    if (key === 'permit') {
      return this.permitSelectedFiles.fileNames.length || this.permitUploadedFiles.fileNames.length;
    } else if (key === 'vendorBillAmount') {
      return this.invoiceSelectedFiles.fileNames.length || this.invoiceUploadedFiles.fileNames.length;
    } else if (key === 'toll') {
      return this.tollSelectedFiles.fileNames.length || this.tollUploadedFiles.fileNames.length;
    } else if (key === 'parking') {
      return this.parkingSelectedFiles.fileNames.length || this.parkingUploadedFiles.fileNames.length;
    } else if (key === 'others') {
      return this.othersSelectedFiles.fileNames.length || this.othersUploadedFiles.fileNames.length;
    }
  }

  checkOthersFieldVisibility() {
    if (this.miscelleneousConfig['showOthersAmountField'] === 'true') {
      return this.saveChangesButton && this.miscelleneousConfig['othersFileUploadMandatory']
      && this.miscelleneousConfig['othersFileUploadMandatory'] === 'true'
      && this.formDetails.get('Adjustments').get('otherCost').value
      && !this.checkSelectedFile('others');
    } else {
      return this.saveChangesButton &&  this.miscelleneousConfig['othersFileUploadMandatory']
      && this.miscelleneousConfig['othersFileUploadMandatory'] === 'true'
      && !this.checkSelectedFile('others');
    }
  }

  saveChanges() {
    this.startDutyTime = `${this.invoiceEditDates.dutyStartDate} ${this.invoiceEditTime.dutyStartTime}`;
    this.endDutyTime = `${this.invoiceEditDates.dutyEndDate} ${this.invoiceEditTime.dutyEndTime}`;
    this.startTripTime = `${this.invoiceEditDates.tripStartDate} ${this.invoiceEditTime.tripStartTime}`;
    this.endTripTime = `${this.invoiceEditDates.tripEndDate } ${this.invoiceEditTime.tripEndTime}`;

    this.saveChangesButton = true;
    if (this.adjustmentConfig.config.visibility.visible) {
      setTimeout(() => {
        this.countError = document.getElementsByClassName('isVisible').length;
        if (this.countError === 0) {
          this.saveAllDetails();
        }
      }, 0);
    } else {
      this.saveAllDetails();
    }
  }

  saveAllDetails() {
    this.formDetails.updateValueAndValidity();
    if (!this.formDetails.valid) {
      this.markFormGroupDirty(this.formDetails);
    } else {
      let adjustmentInfo = null;
      if (this.adjustmentConfig.config.visibility.visible) {
        adjustmentInfo = this.getTabFormValue('Adjustments');
        Object.keys(adjustmentInfo).forEach((adjust) => {
          if (adjustmentInfo[adjust] === '') {
            adjustmentInfo[adjust] = 0;
          }
        });
      }
      const saveUploadFiles = this.setFilesForUpload();
      if (this.uploadedDocumentList) {
      saveUploadFiles.uploadedFiles.push(...this.uploadedDocumentList);
      }
      const inforequest = {
        bookingId: this.bookingId,
        modifierBuid: this.authService.user.buId,
        modifierGuid: this.authService.user.employeeGuid,
        client: this.authService.client.client,
        adjustmentInfo,
        tripInfo: this.getTabFormValue('Trip Details'),
        bookingInfo: this.getBookingInfo(),
        uploadedFiles: saveUploadFiles.uploadedFiles,
      };
      const filesDto = {
        invoiceUpdateInfo: inforequest,
        uploadingFiles: saveUploadFiles.uploadingFiles
      };

      this.isLoading = true;
      const updateData = this.invoiceViewService.uploadAllInvoiceDocuments(filesDto);

      updateData.
      pipe(takeUntil(this.destroy$)).
      subscribe((response1) => {
        const navigationExtras: NavigationExtras = {
          state: {
            updatedInvoice: this.bookingId,
            showApprovedToast: false
          }
        };
        this.isLoading = false;
        this.router.navigate(['invoicing'], navigationExtras);
      },
      (error) => {
          this.isLoading = false;
          this.invoiceDetailsError = error.error.message;
      });
    }
  }

  hideInvoiceError = () => {
    this.invoiceDetailsError = '';
  }

  onStepClick(step) {
    this.activeStep = step;
  }

  cancelClick() {
    this.router.navigate(['/invoicing']);
  }

  setDisplayNameForCategory(elementKey) {
    return this.commonService.getConfigForElementKey(this.config.adjustment, elementKey).config.displayName.toUpperCase();
  }

  checkFileSize() {
    if (this.totalSize / 1000000 > 20) {
      this.saveButtonDisabled = true;
      this.showFileSizeError = true;
    } else {
      this.saveButtonDisabled = false;
      this.showFileSizeError = false;
    }
  }

  setImageForUpload(files: any, uploadType: string, elementKey: string) {
    this.fileToUpload = files;
    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < this.fileToUpload.length; i++) {
      this.fileName.push(this.fileToUpload[i].name);
      this.totalSize += this.fileToUpload[i].size;
    }
    this.checkFileSize();

    this.uploadType = uploadType;
    if (uploadType === 'TOLL') {
      if (!this.tollSelectedFiles.displayName) {
        this.tollSelectedFiles.displayName = this.setDisplayNameForCategory(elementKey);
      }
      this.tollSelectedFiles.fileNames.push(...this.fileName);
      this.tollSelectedFiles.files.push(...files);
    } else if (uploadType === 'PARKING') {
      if (!this.parkingSelectedFiles.displayName) {
        this.parkingSelectedFiles.displayName = this.setDisplayNameForCategory(elementKey);
      }
      this.parkingSelectedFiles.fileNames.push(...this.fileName);
      this.parkingSelectedFiles.files.push(...files);
    } else if (uploadType === 'PERMIT') {
      if (!this.permitSelectedFiles.displayName) {
        this.permitSelectedFiles.displayName = this.setDisplayNameForCategory(elementKey);
      }
      this.permitSelectedFiles.fileNames.push(...this.fileName);
      this.permitSelectedFiles.files.push(...files);
    } else if (uploadType === 'INVOICE') {
      if (!this.invoiceSelectedFiles.displayName) {
        this.invoiceSelectedFiles.displayName = this.setDisplayNameForCategory(elementKey);
      }
      this.invoiceSelectedFiles.fileNames.push(...this.fileName);
      this.invoiceSelectedFiles.files.push(...files);
    } else if (uploadType === 'OTHERS') {
      if (!this.othersSelectedFiles.displayName) {
        this.othersSelectedFiles.displayName = this.setDisplayNameForCategory(elementKey);
      }
      this.othersSelectedFiles.fileNames.push(...this.fileName);
      this.othersSelectedFiles.files.push(...files);
    }
    this.fileName = [];

    }

  previewDocument(file) {
    this.showPreview = true;
    this.selectedFileName = file.name;
    this.selectedFileType = file.type;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
    this.previewUrl = reader.result.toString();
    };

  }

  previewUploadedDocument(file) {
    if (file.fileName.endsWith('pdf')) {
      this.selectedFileName = file.fileName;
      this.showPreview = true;
      this.selectedFileType = 'application/pdf';
      this.previewUrl = file.fileUrl;
    } else {
      this.selectedFileName = file.fileName;
      this.showPreview = true;
      this.previewUrl = file.fileUrl;
    }
  }

  closePopOver() {
    this.showPreview = false;
    this.previewUrl = '';
  }

  cancelFileSelection(uploadType, index, section) {
    if (section === 'selected') {
      if (uploadType === 'TOLL') {
        this.totalSize = this.totalSize - this.tollSelectedFiles.files[index].size;
        this.checkFileSize();
        this.tollSelectedFiles.fileNames.splice(index, 1);
        this.tollSelectedFiles.files.splice(index, 1);
      } else if (uploadType === 'PARKING') {
        this.totalSize = this.totalSize - this.parkingSelectedFiles.files[index].size;
        this.checkFileSize();
        this.parkingSelectedFiles.fileNames.splice(index, 1);
        this.parkingSelectedFiles.files.splice(index, 1);
      } else if (uploadType === 'PERMIT') {
        this.totalSize = this.totalSize - this.permitSelectedFiles.files[index].size;
        this.checkFileSize();
        this.permitSelectedFiles.fileNames.splice(index, 1);
        this.permitSelectedFiles.files.splice(index, 1);
      } else if (uploadType === 'INVOICE') {
        this.totalSize = this.totalSize - this.invoiceSelectedFiles.files[index].size;
        this.checkFileSize();
        this.invoiceSelectedFiles.fileNames.splice(index, 1);
        this.invoiceSelectedFiles.files.splice(index, 1);
      } else if (uploadType === 'OTHERS') {
        this.totalSize = this.totalSize - this.othersSelectedFiles.files[index].size;
        this.checkFileSize();
        this.othersSelectedFiles.fileNames.splice(index, 1);
        this.othersSelectedFiles.files.splice(index, 1);
      }
    } else if (section === 'uploaded') {
      if (uploadType === 'TOLL') {
        this.totalSize = this.totalSize - this.tollUploadedFiles.fileNames[index].filesize;
        this.checkFileSize();
        this.matchDeletedItem(index, this.tollUploadedFiles);
        this.tollUploadedFiles.fileNames.splice(index, 1);
      } else if (uploadType === 'PARKING') {
        this.totalSize = this.totalSize - this.parkingUploadedFiles.fileNames[index].filesize;
        this.checkFileSize();
        this.matchDeletedItem(index, this.parkingUploadedFiles);
        this.parkingUploadedFiles.fileNames.splice(index, 1);
      } else if (uploadType === 'PERMIT') {
        this.totalSize = this.totalSize - this.permitUploadedFiles.fileNames[index].filesize;
        this.checkFileSize();
        this.matchDeletedItem(index, this.permitUploadedFiles);
        this.permitUploadedFiles.fileNames.splice(index, 1);
      } else if (uploadType === 'INVOICE') {
        this.totalSize = this.totalSize - this.invoiceUploadedFiles.fileNames[index].filesize;
        this.checkFileSize();
        this.matchDeletedItem(index, this.invoiceUploadedFiles);
        this.invoiceUploadedFiles.fileNames.splice(index, 1);
      } else if (uploadType === 'OTHERS') {
        this.totalSize = this.totalSize - this.othersUploadedFiles.fileNames[index].filesize;
        this.checkFileSize();
        this.matchDeletedItem(index, this.othersUploadedFiles);
        this.othersUploadedFiles.fileNames.splice(index, 1);
      }
    }
  }

  matchDeletedItem(index, file) {
    const matchedIndex = this.uploadedDocumentList.findIndex((doc) => {
      return doc.id === file.fileNames[index].id;
    });
    this.uploadedDocumentList[matchedIndex].isDeleted = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleToast() {
    this.showUploadSuccess = false;
  }

  getVendorValue(option) {
    return option.guid;
  }

  getVendorLabel(option) {
    return option.vendorName;
  }

}
